import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import {config} from '../../../config'
import Sidebar from '../../../components/sidebar/Sidebar'
import Header from '../../../components/headerbar/Header'
import _ from 'lodash'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TryOn = () => {
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const [details, setDetails] = useState(null)
  const [isDataLoaded, setIsDataLoaded] = useState(false)
  const navigate = useNavigate()
  useEffect(() => {
    getTryOn().then(_ => setIsDataLoaded(true))
  }, [])

  const getTryOn = async () => {
    let sliderResult = await fetch(config.apiurl + '/tryonlists/get_tryon')
    sliderResult = await sliderResult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))

    setDetails(sliderResult?.data?.results)
  }

  const deleteSlider = async (id) => {
    let deletecat = await fetch(config.apiurl + '/tryonlists/' + id, {
      method: 'Delete',
      headers: {
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    })
    deletecat = await deletecat.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
    if (deletecat) {
      getTryOn()
    }
  }

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Try On</h6>
                    </div>
                    {isDataLoaded &&  _.isEmpty(details) && (
                      <div className="col-6 text-end">
                        <Link
                          className="btn bg-gradient-dark mb-0"
                          to="/tryon/add"
                        >
                          <i className="fas fa-plus" aria-hidden="true"></i>
                          &nbsp;&nbsp;Add Tryon details
                        </Link>
                      </div>
                    )}
                  </div>
                </div>

                <div className="card-body px-0 pt-0 pb-2">
                  <div className="table-responsive p-3">
                    <table className="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th className="text-secondary opacity-7 ps-2">
                            S.No
                          </th>
                          <th className="text-secondary opacity-7 ps-2">
                            Video
                          </th>
                          <th className="text-secondary opacity-7 ps-2">
                            Title
                          </th>
                          <th className="text-secondary opacity-7 ps-2">
                            Content
                          </th>
                          <th className="text-secondary opacity-7">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {details &&
                          details.length &&
                          details.map((item, index) => (
                            <tr key={item._id}>
                              <td>{index + 1}</td>
                              <td>
                                <div className="d-flex px-2 py-1">
                                  <div>
                                    <video width="320" height="240" controls>
                                      <source
                                        src={
                                          config.fileurl + item.video ||
                                          '/img/error.png'
                                        }
                                        type="video/mp4"
                                        className="avatar avatar-sm me-3"
                                        alt={item.title}
                                      />
                                    </video>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column justify-content-center">
                                  <h6 className="mb-0 text-sm">{item.title}</h6>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column justify-content-center">
                                  <h6
                                    className="mb-0 text-sm"
                                    style={{ textWrap: 'balance' }}
                                  >
                                    {item.content}
                                  </h6>
                                </div>
                              </td>

                              <td>
                                <Link
                                  to={'/tryon/edit/' + item._id}
                                  className="btn btn-link text-dark px-3 mb-0"
                                >
                                  <i
                                    className="fas fa-pencil-alt text-dark me-2"
                                    aria-hidden="true"
                                  ></i>
                                  Edit
                                </Link>
                                <div
                                  className="btn btn-link text-danger text-gradient px-3 mb-0"
                                  onClick={() => deleteSlider(item._id)}
                                >
                                  <i
                                    className="far fa-trash-alt me-2"
                                    aria-hidden="true"
                                  ></i>
                                  Delete
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export default TryOn
